export var RumEventType;
(function (RumEventType) {
    RumEventType["ACTION"] = "action";
    RumEventType["ERROR"] = "error";
    RumEventType["LONG_TASK"] = "long_task";
    RumEventType["VIEW"] = "view";
    RumEventType["RESOURCE"] = "resource";
})(RumEventType || (RumEventType = {}));
//# sourceMappingURL=typesV2.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/typesV2.js
// module id = h7Mb
// module chunks = 1